module.exports = __webpack_public_path__ + "static/img/117_TO8_1649_og.e6e6499.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/117_TO8_1649_og.jpg
// module id = SV4Z
// module chunks = 0